import './Home.scss';

import Nav from "../components/Nav"
import { Button } from './Reusable';

import Statement from './Statement';
import Impact from './Impact';
import Process from './Process';
import UseCases from './UseCases';
import CaseStudy from './CaseStudy';
import TakeAction from './TakeAction';
import About from './About';
import FounderPreview from './FounderPreview';
import Services from './Services';
import Milestones from './Milestones';
import Contact from './Contact';
import Footer from './Footer';

import { useState } from 'react'
import useReveal from '../utility/useReveal'
import useFunnelMilestones from '../utility/useFunnelMilestones'

import heroLoop from '../resources/video/hero-loop.mp4'

function Home() {

    useReveal()
    useFunnelMilestones()

    // The headline lands over a flat blue field, then the footage cross-fades in
    // underneath once there is enough of the file to play. Holding the blue reads
    // as intentional rather than slow.
    const [isVideoReady, setIsVideoReady] = useState(false)

    return (
        <>
            <Nav />

            <main>
            <div className="Home" id='home'>
                <div className='Home-container'>
                    <h1 className="Home-header"><span>Illuminate</span> your story.</h1>

                    {/* The first ask used to be three sections down. Anyone already
                        convinced by the hero had to scroll to act on it. */}
                    <div className="Home-cta">
                        <Button title="Start a project" flameon={true} source="Hero" />
                    </div>
                </div>
                
                <div className='video-overlay'></div>
                <div className='Home-video-container'>
                    {/* Self-hosted rather than a YouTube embed: YouTube paints a large
                        pause indicator over the video for the first seconds of playback, on
                        load and again on every loop, and no player parameter turns it off. */}
                    <video className={`Home-video ${isVideoReady ? "ready" : ""}`}
                        playsInline
                        autoPlay
                        muted
                        loop
                        preload='auto'
                        onCanPlay={() => setIsVideoReady(true)}>
                        <source src={heroLoop} type='video/mp4' />
                    </video>
                </div>

            </div>
            <Statement />
            <Impact />
            <Process />
            <UseCases />
            <CaseStudy />
            <TakeAction />
            <About />
            <FounderPreview />
            <Services />
            <Milestones />
            <Contact />
            </main>
            <Footer />
        </>
    );
}

export default Home;
